import React, { CSSProperties } from 'react';
import { useAuth } from 'auth/Auth0Provider';
import { LoadingIndicator, IndicatorSize } from '../shared/other/LoadingIndicator';
import { Button } from 'antd';
import { IAuthAppState } from 'auth/IAuthAppState';
import { loginWithRedirect } from 'auth/Authentication';
import { getAuthConfig } from 'auth/AuthConfig';
import { sidebarRoutes, IRoute } from 'components/navigation/routes';
import { RouteId } from 'types/frontend_models/navigation/RouteId';
import { fixPublicPath } from 'functions/url/URLFunctions';

export function InitPage()
{
	const auth = useAuth();

	if (!auth.isAuthenticated) {
		let imageUrl = fixPublicPath('/images/loginbg3@720p.jpg');
		const bgImageStyle: CSSProperties = {
			backgroundImage: `url(${imageUrl})`
		};

		let initContainerClassName = 'init-container bg-white';
		let initContentClassName = 'content -init txt-center';
		if (!auth.setupCompleted) {
			initContainerClassName += ' -loading';
			initContentClassName += ' -loading';
		} else {
			initContentClassName += ' -login';
		}

		return (
			<div className="init-page">
				<div className="bg-image -init" style={bgImageStyle} />
				<div className={initContainerClassName}>
					<div className={initContentClassName}>
						{
							!auth.setupCompleted &&
							<div className="pos-abs-cover">
								<LoadingIndicator
									outContainerClassName="pos-abs-center"
									indicatorSize={IndicatorSize.large}
								/>
							</div>
						}
						{
							auth.setupCompleted &&
							<React.Fragment>
								<img className="company-logo -init" src={fixPublicPath("/images/logo/AptecLogo.png")} alt="Aptec logo" />
								{/* <div className="w100p mgt-20" style={{ height: 1, background: 'gray' }}></div> */}
								<div className="pdt-20 mh-vh-20 col-auto pos-rel login-text -init">
									<p className="pos-abs-center w100p">
										Welcome to Aptec.<br />Please <strong>sign in</strong> to proceed.
									</p>
								</div>
								<Button
									onClick={onLoginClick}
									type="primary"
									className="login-button -init"
								>
									Sign in
								</Button>
							</React.Fragment>
						}
					</div>
				</div>
			</div>
		);
	} else {
		return null;
	}
};

function onLoginClick()
{
	const route = sidebarRoutes.find(r => r.routeId === RouteId.home) as IRoute;
	const appState: IAuthAppState = { path: route.path }

	const config = getAuthConfig();
	loginWithRedirect(
		{
			appState: appState,
			scope: config.scope,
			audience: config.audience,
			redirect_uri: config.redirect_uri
		}
	);
}